var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_2973)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.265 7.22933C9.35 8.49016 9.5625 9.72266 9.9025 10.8985L8.2025 12.5985C7.62167 10.8985 7.25333 9.09933 7.12583 7.22933H9.265ZM23.2333 24.2577C24.4375 24.5977 25.67 24.8102 26.9167 24.8952V27.006C25.0467 26.8785 23.2475 26.5102 21.5333 25.9435L23.2333 24.2577ZM10.625 4.396H5.66667C4.8875 4.396 4.25 5.0335 4.25 5.81266C4.25 19.1152 15.0308 29.896 28.3333 29.896C29.1125 29.896 29.75 29.2585 29.75 28.4793V23.5352C29.75 22.756 29.1125 22.1185 28.3333 22.1185C26.5767 22.1185 24.8625 21.8352 23.2758 21.311C23.1342 21.2543 22.9783 21.2402 22.8367 21.2402C22.4683 21.2402 22.1142 21.3818 21.8308 21.651L18.7142 24.7677C14.705 22.7135 11.4183 19.441 9.37833 15.4318L12.495 12.3152C12.8917 11.9185 13.005 11.366 12.8492 10.8702C12.325 9.2835 12.0417 7.5835 12.0417 5.81266C12.0417 5.0335 11.4042 4.396 10.625 4.396Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_2973"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white",
    transform: "translate(0 0.145996)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.607c136f435d3c2aee4cd05bd34415df.svg";
export { ForwardRef as ReactComponent };